import { render, staticRenderFns } from "./contractForClient.vue?vue&type=template&id=08686ac7&scoped=true"
import script from "./contractForClient.vue?vue&type=script&lang=js"
export * from "./contractForClient.vue?vue&type=script&lang=js"
import style0 from "./contractForClient.vue?vue&type=style&index=0&id=08686ac7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08686ac7",
  null
  
)

export default component.exports